import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_DESIGNER: MapaCargo = 
{
  id: 'designer',
  titulo: 'Designer',
  setor: 'Criação',
  secoes: [
    {
      id: 'responsabilidades',
      titulo: 'Responsabilidades',
      atividades: [
        'Direção de arte;',
        'Criação de peças para marketing;',
        'Criação de layouts para sites e lojas virtuais;',
        'Criação de templates de e-mail;',
        'Reuniões de kick-off, apresentação e acompanhamento de projeto;',
        'UX Design para projetos e suporte contínuo;',
        'Análise de usabilidade;',
        'Definição de fluxos e jornadas;',
        'Criação de wireframes e protótipos;',
        'Otimização de interfaces  e atendimento ao cliente.',
      ],
    },
  ],
}
